import React, { HTMLAttributes } from 'react';
import bemBlock from '@gik/core/utils/bemBlock';

interface IFormErrorProps extends HTMLAttributes<HTMLDivElement> {
  status?: string;
  message: React.ReactNode;
  centered?: boolean;
}

export default function FormError({
  message,
  className,
  status,
  centered,
  ...otherProps
}: IFormErrorProps): React.ReactElement {
  const bem = bemBlock('form-error');
  return (
    <div className={bem(null, [{ centered }], className)} {...otherProps}>
      {status}
      {message}
    </div>
  );
}
